/* eslint-disable camelcase */
import { Button, Dialog, Grid, DialogContent, DialogActions, Tooltip, Typography, Icon, Stack } from '@mui/material'
import { AGRI } from 'administration/components/user/constants/HabilitationConstants'
import AgriAction from 'agriAdministration/actions/AgriAction'
import Checkbox from 'components/forms/Checkbox'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import ExportFileModal from 'components/modal/ExportFileModal'
import { push } from '@lagunovsky/redux-react-router'
import ExportAction from 'export/actions/ExportAction'
import { EXPORT_JOB_STATUS } from 'export/constants/ExportConstants'
import { compact, lowerCase, sortBy, includes } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { nbPerPageLabelMedium, nbPerPageLabelHuge } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import DtoDeclaration from 'survey/dto/DtoDeclaration'
import ToastrAction from 'toastr/actions/ToastrAction'
import { getDate, getDateExport } from 'utils/DateUtil'
import { formatData } from 'utils/ExportDataUtil'
import { getLocalStorageJson, setLocalStorageJson } from 'utils/FormUtils'
import { getLogin, getSetting } from 'utils/SettingUtils'
import { formatMilliers, formatPhone, normalizeString } from 'utils/StringUtil'
import DtoDeclarationExportFull from '../../dto/DtoDeclarationExportFull'
import DtoSurvey from '../../dto/DtoSurvey'
import DeclarationsFilterPanel from './DeclarationsFilterPanel'
import { DECLARATION_STATUS, LOCAL_DECLARATIONS_FILTERS, POINT_STATUS_EXPLOITATION, SURVEY_STATUS, SURVEY_TYPES } from 'agriAdministration/constants/AgriConstants'
import { hasValue } from 'utils/NumberUtil'
import { getDeclarationAdvancement } from '../../../utils/AgriUtils'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { ALIGN, CardTable } from 'components/datatable/NewTable'
import { darkBlue } from 'utils/constants/ColorTheme'
import { CheckBox, CheckCircle, CheckCircleOutline, Done, Edit, FileDownload, HourglassFull, PlayCircleOutline, RemoveRedEye } from '@mui/icons-material'
import { contentsPath } from 'conf/basepath'

const headersTable = ['statusIcon', 'codification', 'city', 'sampler', 'structureType', 'advancement',
    'updateDate', 'modifIcon', 'nbPtReal', 'realVolume', 'nbPtPrevi', 'prevVolume', 'adjustedEstimWrap', 'administrator']

const exportHeaders = ['validatedDec', 'codification', 'cityCode', 'cityLabel', 'samplerName', 'email', 'phoneTel', 'mobile', 'structureType',
    'advancement', 'status', 'updateDate', 'modif', 'nbPtReal', 'realVolume', 'nbPtPrevi', 'prevVolume', 'adjustedEstim', 'administrators']
const exportHeadersFull = ['activityEndDate', 'codification', 'structureType', 'civility', 'name', 'address', 'additionnalAddress',
    'inseeCode', 'postalCode', 'city', 'phoneTel', 'mobile', 'fax', 'email', 'comment', 'siret', 'pacage', 'octagri_aura', 'octagri_local', 'muse',
    'agence', 'advancement', 'modif', 'nbPtReal', 'realVolume', 'nbPtPrevi', 'prevVolume', 'adjustedEstim', 'administrators', 'updateDate', 'updateDateAdmin', 'userValidationDate']
const headersExportAgency = ['codification', 'structureType', 'civility', 'name', 'address', 'additionnalAddress', 'inseeCode',
    'postalCode', 'city', 'phoneTel', 'mobile', 'fax', 'email', 'siret', 'pacage', 'agence', 'advancement']

const SurveyDeclarationsPanel = ({ newSurvey, onChange, actualiseSelfAssign, params, exportFullSurvey, readMode }) => {
    const [filters, setFilters] = useState(getLocalStorageJson(LOCAL_DECLARATIONS_FILTERS) || { shut: true, adjourned: true })
    const [modalFilters, setModalFilters] = useState({})
    const [tmpDeclarations, setTmpDeclarations] = useState([])
    const [open, setOpen] = useState(false)
    const [openDeclarationExportModal, setOpenDeclarationExportModal] = useState(false)
    const [openTableExportModal, setOpenTableExportModal] = useState(false)
    const [selectedDeclaration, setSelectedDeclaration] = useState({})
    const [settings, setSettings] = useState({})
    const [modelDeclaration, setModelDeclaration] = useState()
    const [modelSynthese, setModelSynthese] = useState()
    const [modelNotification, setModelNotification] = useState()

    const {
        contributors,
        cities,
        exploitationsExportFullData,
        managementUnits,
        watersheds,
        survey,
        allModelsByType,
        accountUser,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        cities: store.CityReducer.cities,
        exploitationsExportFullData: store.AgriReducer.exploitationsExportFullData,
        managementUnits: store.ManagementUnitReducer.managementUnits,
        watersheds: store.WatershedReducer.watersheds,
        survey: store.AgriReducer.survey,
        allModelsByType: store.AdministrationReducer.allModelsByType,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const dispatch = useDispatch()

    useEffect(() => {
        getSetting(newSurvey?.link_params, 'defaultModelDeclaration')
        getSetting(newSurvey?.link_params, 'defaultModelSynthese')
        getSetting(newSurvey?.link_params, 'defaultModelNotification')
    }, [])

    const filterExploitation = useMemo(() => exploitationsExportFullData.filter(e => !((e.endDate && e.endDate < newSurvey.startDate) || e.status === POINT_STATUS_EXPLOITATION.CLOSED) || tmpDeclarations.find(se => se.idExploitation === e.idExploitation)), [exploitationsExportFullData, tmpDeclarations, newSurvey])

    const getAdvancementIcon = (statusCode) => {
        if (statusCode === DECLARATION_STATUS.VALIDATED) {
            return (<Tooltip title={i18n.validatedDefinitely}><CheckCircle sx={{ fontSize: '1.7rem' }}/></Tooltip>)
        } else if (statusCode === DECLARATION_STATUS.VALIDATED_BY_ADMIN) {
            return (<Tooltip title={i18n.validatedByAdmin}><CheckCircleOutline sx={{ fontSize: '1.7rem' }}/></Tooltip>)
        } else if (statusCode === DECLARATION_STATUS.FINALIZED_BY_AGRI) {
            return (<Tooltip title={i18n.finalizedByUser}><Done sx={{ fontSize: '1.7rem' }}/></Tooltip>)
        } else if (statusCode === DECLARATION_STATUS.STARTED) {
            return (<Tooltip title={i18n.inProgress}><PlayCircleOutline sx={{ fontSize: '1.7rem' }}/></Tooltip>)
        }
        return (<Tooltip title={i18n.notStarted}><HourglassFull sx={{ fontSize: '1.7rem' }}/></Tooltip>)
    }

    const goToDeclaration = (idExploitation, idDeclaration) => {
        dispatch(AgriAction.changeExploitationAdministrator(idExploitation)).then(() => {
            dispatch(push(`/survey/${params.id}/declaration/${idDeclaration}/stepper/0`))
        })
    }

    const selfAssign = (id) => {
        dispatch(AgriAction.changeExploitationAdministrator(id, true)).then(() => {
            actualiseSelfAssign(newSurvey.idSurvey, newSurvey.link_declarations)
        })
    }

    const desaffect = (id) => {
        dispatch(AgriAction.deleteExploitationAdministrator(id)).then(() => {
            actualiseSelfAssign(survey.idSurvey, survey.link_declarations)
        })
    }

    const getSurveyData = () => {
        const isConsult = accountUser?.consultant === '1'
        return survey.link_declarations.map(declaration => {
            const administrators = declaration.idExploitation && survey.link_codifications.filter(c => c.idExploitation === declaration.idExploitation && c.codification !== declaration.codification) || []
            const displaySelfAssignButton = !administrators.find(adm => adm.codification === getLogin())
            const cityValue = declaration.cityCode ? `${declaration.city} [${declaration.cityCode}]` : ''
            const consult = survey.statusCode === SURVEY_STATUS.ARCHIVED || declaration.statusCode >= DECLARATION_STATUS.VALIDATED || isConsult
            const exploitation = exploitationsExportFullData.find((e) => e.idExploitation === declaration.idExploitation) || {}
            const advancement = getDeclarationAdvancement(declaration)
            return {
                ...declaration,
                exploitation,
                adjourned: !(exploitation.link_points || []).find((lp) => !lp.endDate || lp.endDate > moment().valueOf()),
                // table values
                statusIcon: { value: <div style={{ padding: '3px' }}>{getAdvancementIcon(declaration.statusCode)}</div>, sortValue: declaration.statusCode },
                codification: { value: declaration.codification },
                city: {
                    value: (
                        <Tooltip title={cityValue}>
                            <Typography sx={{ ':hover': { cursor: 'pointer' } }}>{ cityValue }</Typography>
                        </Tooltip>
                    ),
                    style: {
                        width: '8vw',
                    },
                },
                sampler: {
                    value: (
                        <Tooltip title={`${declaration.name}\n${i18n.email} : ${declaration.email || ''} \n${i18n.phoneTel} : ${formatPhone(declaration.phoneTel) || ''} \n${i18n.mobile} : ${formatPhone(declaration.mobile) || ''}`}>
                            <Typography sx={{ ':hover': { cursor: 'pointer' } }}>{ declaration.name }</Typography>
                        </Tooltip>
                    ),
                    style: {
                        width: '10vw',
                    },
                    sortValue: declaration.name,
                    onClick: () => dispatch(push(`/referencial/contributor/${declaration.idContributor}`)),
                },
                structureType: { value: declaration.structureType },
                advancement: {
                    value: `${advancement}%`,
                    sortValue: advancement,
                },
                updateDate: getDate(declaration.updateDate),
                updateDateTable: {
                    value: getDate(declaration.updateDate),
                    sortValue: declaration.updateDate,
                    tooltip: (
                        <Stack>
                            <Grid>{`${i18n.validationIrrigator} : ${declaration.dateValidationIrrigant ? getDate(declaration.dateValidationIrrigant) : '-'}${declaration.updateLogin && declaration.dateValidationIrrigant ? ` (${declaration.updateLogin})` : ''}`}</Grid>
                            <Grid>{`${i18n.modificationAdmin} : ${declaration.dateMajAdmin ? getDate(declaration.dateMajAdmin) : '-'}${declaration.loginMajAdmin ? ` (${declaration.loginMajAdmin})` : ''}`}</Grid>
                            <Grid>{`${i18n.modificationIrrigator} : ${declaration.updateDate ? getDate(declaration.updateDate) : '-'}${declaration.updateLogin ? ` (${declaration.updateLogin})` : ''}`}</Grid>
                        </Stack>
                    ),
                },
                nbPtReal: {
                    value: formatMilliers(declaration.nbPtReal),
                    sortValue: declaration.nbPtReal,
                },
                adjustedEstimWrap: {
                    value: declaration.volumesAdjusted ? (
                        <CheckBox />
                    ) : null,
                    align: ALIGN.CENTER,
                },
                adjustedEstim: { value: declaration.volumesAdjusted ? i18n.yes : i18n.no },
                realVolume: {
                    value: formatMilliers(declaration.realVolume),
                    align: ALIGN.RIGHT,
                    sortValue: declaration.realVolume,
                },
                nbPtPrevi: {
                    value: formatMilliers(declaration.nbPtPrevi),
                    sortValue: declaration.nbPtPrevi,
                },
                prevVolume: {
                    value: formatMilliers(declaration.prevVolume),
                    align: ALIGN.RIGHT,
                    sortValue: declaration.prevVolume,
                },
                administrator: {
                    data: administrators.map(c => c.codification).join(', '),
                    value: (
                        <Tooltip title={administrators.map(c => c.codification).join(', ')}>
                            <Typography sx={{ ':hover': { cursor: 'pointer' } }}>{ administrators.map(c => c.codification).join(', ') }</Typography>
                        </Tooltip>
                    ),
                    style: {
                        width: '5vw',
                    },
                },
                nullValue2: {
                    value: !isConsult ? (
                        <Tooltip title={displaySelfAssignButton ? i18n.selfAssign: i18n.disaffect}>
                            <Icon sx={{ ':hover': { cursor: 'pointer' } }}>{ displaySelfAssignButton ? 'person_add' : 'person_add_disabled' }</Icon>
                        </Tooltip>
                    ) : null,
                    onClick: isConsult ? () => {} : (displaySelfAssignButton ? () => selfAssign(declaration.idExploitation) : () => desaffect(declaration.idExploitation)),
                },
                nullValue3: {
                    value: (
                        <Tooltip title={consult ? i18n.consult : i18n.edit}>
                            {consult ? <RemoveRedEye sx={{ ':hover': { cursor: 'pointer' } }} /> : <Edit sx={{ ':hover': { cursor: 'pointer' } }} />}
                        </Tooltip>
                    ),
                    onClick: () => goToDeclaration(declaration.idExploitation, declaration.idDeclaration),
                },
                nullValue: {
                    value: <Tooltip title={i18n.export}><FileDownload/></Tooltip>,
                    onClick: () => {
                        setOpenDeclarationExportModal(true)
                        setSelectedDeclaration(declaration)
                    },
                },

                // export values
                validatedDec: declaration.statusCode >= DECLARATION_STATUS.VALIDATED ? i18n.yes : i18n.no,
                cityLabel: declaration.cityCode ? `${declaration.city}` : '',
                samplerName: declaration.name,
                phoneTel: formatPhone(declaration.phoneTel),
                mobile: formatPhone(declaration.mobile),
                status: declaration.statusCode,
            }
        })
    }

    const onValidate = () => {
        onChange({
            link_declarations: tmpDeclarations.map((d) => ({
                statusCode: DECLARATION_STATUS.NOT_STARTED[1],
                idDeclaration: -1,
                idContributor: d.operatorCode,
                idSurvey: newSurvey.idSurvey,
                comment: null,
                ...d,
                updateDate: d.updateDate,
                nullValue: undefined,
            })),
        })

        setOpen(false)
    }

    const onCheck = (exploitation, value, declaration) => {
        if (declaration && declaration.statusCode) {
            dispatch(ToastrAction.warning(i18n.deleteExploitationButDeclarationHasBeenStarted))
        }
        const newTmpDeclarations = value ?
            [ ...tmpDeclarations, new DtoDeclaration({
                ...exploitation,
                statusCode: DECLARATION_STATUS.NOT_STARTED[1],
                idDeclaration: -1,
                idContributor: exploitation.operatorCode,
                idSurvey: survey.idSurvey,
                comment: null,
                updateDate: null,
            }) ]
            : tmpDeclarations.filter(ld => ld.idExploitation !== exploitation.idExploitation)
        setTmpDeclarations(newTmpDeclarations)
    }

    const createAndDownloadEdition = (id, model) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getEditionDeclaration(id, model)).then((json) => window.open(contentsPath + json.targetPath, '_blank'))
    }

    const createSynthesisEdition = (id, model) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getSynthesisDeclaration(id, model)).then((json) => window.open(contentsPath + json.targetPath, '_blank'))
    }

    const getNotification = (idExploitation, year, model) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getNotifEdition(idExploitation, year, model)).then((json) => window.open(contentsPath + json.targetPath, '_blank'))
    }

    const getHashMateriel = (declaration) => {
        return lowerCase((declaration.link_points || []).reduce((acc, p) => `${acc ? `${acc}, ` : ''}${p.code ? `${p.code}, ` : ''}${p.materiels || ''}`, ''))
    }

    const getHash = (declaration, headers) => {
        return normalizeString([...headers, 'email', 'mobile', 'phoneTel', 'legalRepSampler', 'address', 'name'].map(key => declaration[key] && declaration[key].value ? declaration[key].value : declaration[key]))
    }

    const getFilteredData = (data, headers, filterValue) => {
        const includesValue = normalizeString(filterValue || '')
        return data.filter(i => getHashMateriel(i).includes(lowerCase(filterValue)) || getHash(i, headers).includes(includesValue))
    }

    const getFilteredDeclarations = data => {
        const { step0, step1, step2, step3, step4, finalized, validatedByAdmin, validated,
            myFolders, city, managementUnit, subManagementUnit, watershed, adjourned, shut, procedureType } = filters
        const closedFilteredData = shut ? data : data.filter((d) => !d.exploitation.folderClosed)
        const adjournedFilteredData = adjourned ? closedFilteredData : closedFilteredData.filter((d) => !d.adjourned)
        const cityFilteredData = city ? adjournedFilteredData.filter((d) => city === d.cityCode || (d.link_points || []).find((p) => p.cityCode === city)) : adjournedFilteredData
        const myFoldersData = myFolders ? cityFilteredData.filter((d) => d?.administrator?.data?.split(', ')?.includes(getLogin())) : cityFilteredData
        const ugeFilteredData = managementUnit ? myFoldersData.filter(({ link_points }) => link_points && link_points.find((l) => l.managementCode === parseInt(managementUnit))) : myFoldersData
        const subUgeFilteredData = subManagementUnit ? ugeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.subManagementCode === parseInt(subManagementUnit))) : ugeFilteredData
        const watershedFilteredData = watershed ? subUgeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.bvCode === parseInt(watershed))) : subUgeFilteredData
        const procedureFilteredData = hasValue(procedureType) ? watershedFilteredData.filter((d) => procedureType === d.exploitation.procedureType) : watershedFilteredData
        if ((step0 && step1 && step2 && step3 && step4 && finalized && validatedByAdmin && validated) || (!step0 && !step1 && !step2 && !step3 && !step4 && !finalized && !validatedByAdmin && !validated)) {
            return procedureFilteredData
        }
        return procedureFilteredData.filter(d =>
            (step0 && includes(DECLARATION_STATUS.NOT_STARTED, d.statusCode))
            || (step1 && d.lastStep === 1)
            || (step2 && d.lastStep === 2)
            || (step3 && d.lastStep === 3)
            || (step4 && d.lastStep === 4 && d.statusCode === DECLARATION_STATUS.STARTED)
            || (finalized && d.statusCode === DECLARATION_STATUS.FINALIZED_BY_AGRI)
            || (validatedByAdmin && d.statusCode === DECLARATION_STATUS.VALIDATED_BY_ADMIN)
            || (validated && d.statusCode === DECLARATION_STATUS.VALIDATED),
        )
    }

    const getFilteredExploitations = data => {
        const { city, managementUnit, subManagementUnit, watershed } = modalFilters
        const cityFilteredData = city ? data.filter((e) => (city === e.inseeCode) || e.link_points.find((p) => p.cityCode === city)) : data
        const ugeFilteredData = managementUnit ? cityFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.managementCode === parseInt(managementUnit))) : cityFilteredData
        const subUgeFilteredData = subManagementUnit ? ugeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.subManagementCode === parseInt(subManagementUnit))) : ugeFilteredData
        return watershed ? subUgeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.bvCode === parseInt(watershed))) : subUgeFilteredData
    }

    const onOpen = () => {
        setOpen(true)
        setTmpDeclarations(newSurvey.link_declarations)
    }

    const isAllChecked = (tableData) => {
        const selectedIdsArray = tmpDeclarations.map(si => si.idExploitation)
        return !tableData.filter(td => !selectedIdsArray.includes(td.idExploitation)).length
    }

    const onSelectAll = (value) => {
        if (value) {
            const selectedIdsArray = tmpDeclarations.map(si => si.idExploitation)
            const newTmpDeclarations = filterExploitation.filter(e => !selectedIdsArray.includes(e.idExploitation)).map(e =>
                new DtoDeclaration({
                    ...e,
                    statusCode: DECLARATION_STATUS.NOT_STARTED[1],
                    idDeclaration: -1,
                    idContributor: e.operatorCode,
                    idSurvey: survey.idSurvey,
                    comment: null,
                    updateDate: null,
                }),
            )
            setTmpDeclarations([...tmpDeclarations, ...newTmpDeclarations])
        } else {
            setTmpDeclarations(newSurvey.link_declarations)
        }
    }

    const getDialogContent = () => {
        const displayExploitations = filterExploitation.map(e => {
            const declaration = tmpDeclarations.find(se => se.idExploitation === e.idExploitation)
            return {
                ...e,
                sampler: e.name,
                city: e.inseeCode ? `${e.city || ''} [${e.inseeCode}]` : '',
                structureType: e.structureType,
                checkBox: (
                    <Checkbox
                        checked={!!declaration}
                        onChange={value => onCheck(e, value, declaration)}
                        disabled={declaration && declaration.statusCode >= DECLARATION_STATUS.VALIDATED}
                    />
                ),
            }
        })

        const headers = ['codification', 'city', 'sampler', 'structureType']
        const tableData = getFilteredData(getFilteredExploitations(displayExploitations), headers, modalFilters.exploitationFilter)

        return (
            <Grid size={12} container spacing={1}>
                <Grid size={4}>
                    <Input
                        title={i18n.search}
                        value={modalFilters.exploitationFilter}
                        onChange={v => setModalFilters({ ...modalFilters, exploitationFilter: v })}
                    />
                </Grid>
                <Grid size={2}>
                    <Select
                        label={i18n.city}
                        options={cities}
                        value={modalFilters.city}
                        keyLabel='labelWithCode'
                        onChange={(v) => setModalFilters({ ...modalFilters, city: v })}
                        clearFunction
                    />
                </Grid>
                <Grid size={2}>
                    <Select
                        label={i18n.managementUnit}
                        options={sortBy(managementUnits.filter((u) => !u.parent), 'id')}
                        value={modalFilters.managementUnit}
                        keyValue='managementCode'
                        keyLabel='labelWithCode'
                        onChange={(v) => setModalFilters({ ...modalFilters, managementUnit: v, subManagementUnit: null })}
                        clearFunction
                    />
                </Grid>
                <Grid size={2}>
                    <Select
                        label={i18n.subManagementUnit}
                        options={ modalFilters.managementUnit ? sortBy(managementUnits.filter((u) => u.parent === parseInt(modalFilters.managementUnit)), 'id') : []}
                        value={modalFilters.subManagementUnit}
                        keyValue='managementCode'
                        keyLabel='labelWithCode'
                        onChange={(v) => setModalFilters({ ...modalFilters, subManagementUnit: v })}
                        clearFunction
                    />
                </Grid>
                <Grid size={2}>
                    <Select
                        label={i18n.watershed}
                        options={sortBy(watersheds, [e => e?.name?.toLowerCase()])}
                        value={modalFilters.watershed}
                        keyValue='id'
                        keyLabel='labelWithCode'
                        onChange={(v) => setModalFilters({ ...modalFilters, watershed: v })}
                        integerValue
                        clearFunction
                    />
                </Grid>
                <Grid size={12}>
                    <CardTable
                        title={i18n.folders}
                        rows={tableData}
                        headers={[
                            ...headers,
                            { key: 'checkBox', value: <Checkbox checked={isAllChecked(tableData)} onChange={value => onSelectAll(value)}/> },
                        ]}
                        rowsPerPageOptions={nbPerPageLabelMedium}
                        color={darkBlue}
                    />
                </Grid>
            </Grid>
        )
    }

    const exportData = (data, type, headers, title) => {
        const dataWithHeader = data.length > 0 ? [{ ...data[0], headers }, ...data.slice(1)] : []
        const dataFormatted = formatData(dataWithHeader)
        dispatch(ExportAction.export(dataFormatted, type, title))
    }

    const getFilteredTableExport = (tableData, data) => {
        return compact(tableData.map((s) => {
            const formattedData = data.find((d) => d.idDeclaration === s.idDeclaration)
            if (formattedData) {
                return {
                    ...formattedData,
                    modif: s?.modif,
                    nbPtReal: s?.nbPtReal,
                    realVolume: s?.realVolume,
                    nbPtPrevi: s?.nbPtPrevi,
                    prevVolume: s?.prevVolume,
                    adjustedEstim: s?.adjustedEstim,
                    administrators: s?.administrator?.data,
                }
            }
            return null
        }))
    }

    const getSettingsContentsOasis = () => {
        const { senderCode, receiverCode } = settings
        return (
            <Grid container direction='column' alignItems='stretch'>
                <Select
                    label={i18n.sender}
                    options={contributors.filter(c => c.siret)}
                    onChange={c => setSettings({
                        ...settings,
                        senderCode: c,
                    })}
                    value={senderCode}
                    nullLabel='&nbsp;'
                    clearFunction
                    keyLabel='mnemonique'
                />
                <Select
                    label={i18n.receiver}
                    options={contributors.filter(c => c.siret)}
                    onChange={c => setSettings({
                        ...settings,
                        receiverCode: c,
                    })}
                    value={receiverCode}
                    nullLabel='&nbsp;'
                    clearFunction
                    keyLabel='mnemonique'
                />
            </Grid>
        )
    }

    const getDataExportAgency = () => {
        return exploitationsExportFullData.filter((e) => survey.link_declarations.find((d) => d.idExploitation === e.idExploitation)).map((e) => {
            const advancement = getDeclarationAdvancement({ lastStep: e.lastDeclarationStep, statusCode: e.lastDeclarationStatus })
            return {
                ...e,
                city: `${e.city || ''} ${e.inseeCode ? `[${e.inseeCode}]` : ''}`,
                advancement: `${advancement} %`,
            }
        })
    }

    const onExportMultiple = (exportType, idsDeclarations, modelName) => {
        dispatch(ExportAction.runExportTmp({
            id: 0,
            exportType,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: AGRI,
            params: JSON.stringify({
                idsDeclarations,
                modelName,
            }),
        }, i18n.loadingDocumentConsultExportMenu))
    }

    const exportAgencySurvey = (type) => {
        dispatch(AgriAction.exportAgencySurvey(`${i18n.followUp} - ${i18n.waterAgencyExport}_${getDateExport()}`, survey.idSurvey, type)).then((isOk) => {
            if (isOk) {
                dispatch(AgriAction.createSurveysEvents([{
                    idSurvey: survey.idSurvey,
                    eventType: 'e',
                    associateType: 'agency',
                    eventDate: moment().valueOf(),
                    updateLogin: getLogin(),
                }]))
            }
        })
    }

    const exportContactsSurvey = (fileType, data) => {
        const idsExploitations = getFilteredTableExport(data, survey.link_declarations).map(({ idExploitation }) => idExploitation)
        if (idsExploitations.length) {
            dispatch(AgriAction.exportContactsSurvey(`${i18n.exportName}_${i18n.contacts}_${i18n.survey}_${survey.name}[${survey.year}]_${getDateExport()}`, survey.idSurvey, fileType, idsExploitations))
        } else {
            dispatch(ToastrAction.warning(i18n.noDataToExport))
        }
    }

    const exportOasisDeclarations = (declarationsExportData) => {
        const { senderCode, receiverCode } = settings

        const senderSiret = (contributors.find(c => c.code === senderCode) || {}).siret
        const receiverSiret = (contributors.find(c => c.code === receiverCode) || {}).siret

        if (!senderSiret || !receiverSiret) {
            dispatch(ToastrAction.warning(i18n.pleaseCompleteAllField))
        } else {
            dispatch(AgriAction.exportOasisDeclarations(survey.idSurvey, getFilteredTableExport(declarationsExportData, survey.link_declarations).map(({ idExploitation }) => idExploitation), senderSiret, receiverSiret)).then((isOk) => {
                if (isOk) {
                    dispatch(AgriAction.createSurveysEvents([{
                        idSurvey: survey.idSurvey,
                        eventType: 'e',
                        associateType: 'ddt',
                        eventDate: moment().valueOf(),
                        updateLogin: getLogin(),
                    }]))
                }
            })
        }
    }

    const getExportSurveyModal = (declarationsExportData) => {
        const modelsFormatted = allModelsByType.map((m) => ({
            ...m,
            nameFormatted: m.name.split('.')[0],
        }))
        const data = [{
            name: i18n.syntheticExport,
            group: 1,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => exportData(declarationsExportData, 'xlsx', exportHeaders, `${i18n.followUp} - ${i18n.syntheticExport}`),
            }, {
                type: i18n.csv,
                callback: () => exportData(declarationsExportData, 'csv', exportHeaders, `${i18n.followUp} - ${i18n.syntheticExport}`),
            }],
        }, {
            name: i18n.exportFull,
            group: 1,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => exportData(getFilteredTableExport(declarationsExportData, exportFullSurvey), 'xlsx', exportHeadersFull, `${i18n.followUp} - ${i18n.exportFull}`),
            }, {
                type: i18n.csv,
                callback: () => exportData(getFilteredTableExport(declarationsExportData, exportFullSurvey), 'csv', exportHeadersFull, `${i18n.followUp} - ${i18n.exportFull}`),
            }],
        }, {
            name: i18n.exportMassEmptyPDF,
            group: 2,
            formats: [{
                type: 'ZIP',
                callback: () => onExportMultiple('exportEmpty', declarationsExportData.map((d) => d.idDeclaration), modelDeclaration),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriDeclaration')}
                    value={modelDeclaration}
                    onChange={(v) => setModelDeclaration(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        }, {
            name: i18n.exportMassSynthesisPDF,
            group: 2,
            formats: [{
                type: 'ZIP',
                callback: () => onExportMultiple('synthesis', declarationsExportData.map((d) => d.idDeclaration), modelSynthese),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriSynthese')}
                    value={modelSynthese}
                    onChange={(v) => setModelSynthese(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        }, {
            name: i18n.exportMassNotificationPDF,
            group: 2,
            formats: [{
                type: 'ZIP',
                callback: () => onExportMultiple('notification', declarationsExportData.map((d) => d.idDeclaration), modelNotification),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriNotification')}
                    value={modelNotification}
                    onChange={(v) => setModelNotification(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        }, {
            name: i18n.waterAgencyExport,
            group: 3,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => exportAgencySurvey('xlsx'),
            }, {
                type: i18n.csv,
                callback: () => exportAgencySurvey('csv'),
            }],
        }, {
            settingsContent: getSettingsContentsOasis(),
            name: i18n.oasisDDTExport,
            group: 3,
            formats: [{
                type: i18n.xml,
                callback: () => exportOasisDeclarations(declarationsExportData),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.waterAgency} (${i18n.contributors})`,
            group: 3,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => exportData(getDataExportAgency(), 'xlsx', headersExportAgency, `${i18n.contributors}_${i18n.agencyExport}`),
            }, {
                type: i18n.csv,
                callback: () => exportData(getDataExportAgency(), 'csv', headersExportAgency, `${i18n.contributors}_${i18n.agencyExport}`),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.survey} (${i18n.contacts})`,
            group: 4,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => exportContactsSurvey('xlsx', declarationsExportData),
            }, {
                type: i18n.csv,
                callback: () => exportContactsSurvey('csv', declarationsExportData),
            }],
        }, {
            name: i18n.exportFolderWithoutUses,
            group: 4,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => dispatch(AgriAction.exportSurveyNoUses(`${survey.year}_${survey.name} - ${i18n.exportFolderWithoutUses}`, survey.idSurvey, 'xlsx')),
            }, {
                type: i18n.csv,
                callback: () => dispatch(AgriAction.exportSurveyNoUses(`${survey.year}_${survey.name} - ${i18n.exportFolderWithoutUses}`, survey.idSurvey, 'csv')),
            }],
        }]

        return openTableExportModal && (
            <ExportFileModal
                open={openTableExportModal}
                onClose={() => setOpenTableExportModal(false)}
                data={data}
                groups={[{
                    value: 1,
                    name: i18n.table,
                }, {
                    value: 2,
                    name: i18n.mass,
                }, {
                    value: 3,
                    name: i18n.agency,
                }, {
                    value: 4,
                    name: i18n.other,
                }]}
            />
        )
    }

    const exportOasis = () => {
        const { senderCode, receiverCode } = settings

        const senderSiret = (contributors.find(c => c.code === senderCode) || {}).siret
        const receiverSiret = (contributors.find(c => c.code === receiverCode) || {}).siret

        if (!senderSiret || !receiverSiret) {
            dispatch(ToastrAction.warning(i18n.pleaseCompleteAllField))
        } else {
            dispatch(AgriAction.exportOasis(selectedDeclaration, senderSiret, receiverSiret))
        }
    }

    const getExportDeclarationModal = () => {
        const modelsFormatted = allModelsByType.map((m) => ({
            ...m,
            nameFormatted: m.name.split('.')[0],
        }))
        const url = (window.location.href || document.URL).split('#')[0]
        // JSON exports are used to debug
        const displayDev = url.includes('dev.sieau') || url.includes('localhost') || url.includes('recette.manager.medeau')
        const jsons = displayDev ? [
            {
                name: i18n.exportEmptyJson,
                formats: [{
                    type: 'json',
                    callback: () => dispatch(AgriAction.exportEditionJson(selectedDeclaration.idDeclaration)),
                }],
            }, {
                name: i18n.synthesisJson,
                formats: [{
                    type: 'json',
                    callback: () => dispatch(AgriAction.exportEditionFullJson(selectedDeclaration.idDeclaration)),
                }],
            },
        ] : []
        const exportNotif = survey.surveyType === SURVEY_TYPES.ANNUAL ? {
            name: i18n.notification,
            formats: [{
                type: 'pdf',
                callback: () => getNotification(selectedDeclaration.idExploitation, survey.year, modelNotification),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriNotification')}
                    value={modelNotification}
                    onChange={(v) => setModelNotification(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        } : null
        const data = compact([{
            name: i18n.exportEmpty,
            formats: [{
                type: 'pdf',
                callback: () => createAndDownloadEdition(selectedDeclaration.idDeclaration, modelDeclaration),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriDeclaration')}
                    value={modelDeclaration}
                    onChange={(v) => setModelDeclaration(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        }, {
            name: i18n.synthesis,
            formats: [{
                type: 'pdf',
                callback: () => createSynthesisEdition(selectedDeclaration.idDeclaration, modelSynthese),
            }],
            settingsContent: (
                <Select
                    col={6}
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriSynthese')}
                    value={modelSynthese}
                    onChange={(v) => setModelSynthese(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            ),
        }, {
            settingsContent: getSettingsContentsOasis(),
            name: i18n.oasisDDTExport,
            formats: [{
                type: i18n.xml,
                callback: () => exportOasis(selectedDeclaration),
            }],
        }, exportNotif, ...jsons])
        return openDeclarationExportModal && (
            <ExportFileModal
                open={openDeclarationExportModal}
                onClose={() => setOpenDeclarationExportModal(false)}
                data={data}
            />
        )
    }

    const onValidateFilter = (tmpFilters) => {
        setLocalStorageJson(LOCAL_DECLARATIONS_FILTERS, tmpFilters)
        setFilters(tmpFilters)
    }

    const getSelectExploitModal = () => {
        return open && (
            <Dialog
                fullWidth
                maxWidth='lg'
                open={open}
                onClose={() => setOpen(false)}
            >
                <DefaultDialogTitle
                    title={i18n.selectExploitations}
                    onClose={() => setOpen(false)}
                />
                <DialogContent>
                    {getDialogContent(tmpDeclarations)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onValidate} variant='contained' color='primary'>
                        {i18n.validate}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const tableData = getFilteredData(getFilteredDeclarations(getSurveyData()), [...headersTable, 'samplerName'], filters.declarationFilter)

    const actions = [{
        icon: 'compare_arrows',
        color: 'white',
        tooltip: i18n.select,
        onClick: () => onOpen(),
        displayed: !readMode && accountUser.isAdmin === '1',
    }, {
        icon: 'file_download',
        color: 'white',
        tooltip: i18n.export,
        onClick: () => setOpenTableExportModal(true),
    }]

    return (
        <Grid container spacing={1} direction='column'>
            <DeclarationsFilterPanel onValidate={(tmpFilter) => onValidateFilter(tmpFilter)} />
            <CardTable
                title={i18n.declarations}
                actions={actions}
                rows={tableData}
                headers={[
                    'statusIcon',
                    'codification',
                    'sampler',
                    { key: 'structureType', value: i18n.structure },
                    { key: 'city', value: i18n.city, width: '50px' },
                    { key: 'advancement', value: '%', align: ALIGN.RIGHT },
                    { key: 'updateDateTable', value: i18n.update },
                    { key: 'nbPtReal', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbPtRealWrap}</span>) },
                    { key: 'realVolume', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.realVolumeWrap}</span>) },
                    { key: 'nbPtPrevi', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbPtPreviWrap}</span>) },
                    { key: 'prevVolume', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.prevVolumeWrap}</span>) },
                    { key: 'adjustedEstimWrap', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.adjustedEstimWrap}</span>) },
                    { key: 'administrator', value: i18n.administrator, width: '50px' },
                    { key: 'nullValue2', value: '', displayed: readMode },
                    { key: 'nullValue3', value: '', displayed: readMode },
                    { key: 'nullValue', value: '' },
                ]}
                rowsPerPageOptions={nbPerPageLabelHuge}
                color={darkBlue}
            />
            {getSelectExploitModal()}
            {getExportSurveyModal(tableData)}
            {getExportDeclarationModal()}
        </Grid>
    )
}

SurveyDeclarationsPanel.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    newSurvey: PropTypes.instanceOf(DtoSurvey),
    readMode: PropTypes.bool,
    actualiseSelfAssign: PropTypes.func,
    onChange: PropTypes.func,
    exportFullSurvey: PropTypes.arrayOf(DtoDeclarationExportFull),
}

export default SurveyDeclarationsPanel
